import React, { useEffect, useState } from 'react';
import {
    Home, Bed, Settings, Briefcase,
    Wifi, Smartphone, Settings as MotorIcon,
    Settings2,
    Download
} from 'lucide-react';
import toast from "react-hot-toast";
import logo from "../../../assets/windTree/images/login/logowbg.webp"
import { BedSingle } from 'lucide-react';
import { Baby } from 'lucide-react';
import { Bolt } from 'lucide-react';
import { Building2 } from 'lucide-react';
import { Bath } from 'lucide-react';
import { CookingPot } from 'lucide-react';
import { House } from 'lucide-react';
import { MonitorCog } from 'lucide-react';
import Heading from '../Frontend/utils/Heading';
import { useNavigate } from 'react-router-dom';
import Brochure from "../../../assets/windTree/images/Brochure/Brochure.webp"

const STATIC_IMAGE_URL = Brochure;;
const products = [
    {
        title: "MONSOON / INDUSTRIAL PVC BLINDS",
        description: "High quality transparent PVC blinds, ideally suited for balconies, food courts and open spaces.",
        image: "https://i.postimg.cc/g0FgPYR6/Screenshot-2026-02-16-122642.png",
        features: ["Waterproof", "Durable", "Dust Free"]
    },
    {
        title: "ROLLER BLINDS",
        description: "Give your windows a new look with our classic roller shades. Available in blackout and translucent fabrics.",
        image: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&q=80&w=400",
        features: ["Blackout", "Translucent", "Motorized"]
    },
    {
        title: "ZEBRA BLINDS",
        description: "Dual layering of sheer and solid fabric gives you precise light control and a modern look.",
        image: "https://i.postimg.cc/cJ0fm6wz/Screenshot-2026-02-16-122917.png",
        features: ["Light Control", "Modern Design", "Easy Install"]
    },
    {
        title: "DREAM BLINDS",
        description: "Premium fabrics that are the perfect blend of style, functionality, and quality for your home.",
        image: "https://i.postimg.cc/Xq4MNfCz/Screenshot-2026-02-16-122238.png",
        features: ["Premium Fabric", "Elegant Look"]
    },
    {
        title: "TRIPLE BLINDS",
        description: "Classic folding style that adds a soft, fabric-focused touch to any interior design.",
        image: "https://i.postimg.cc/RZM0ptpt/Screenshot-2026-02-16-122005.png",
        features: ["Translucent", "Blackout"]
    },
    {
        title: "WOODEN BLINDS",
        description: "Precision crafted from the finest hardwoods, including genuine Oak and Cherry, Wintree Wood blinds exude tradition and character. The warm wood tones of these Horizontal Blinds enhance any room, whether a country kitchen or a tailored bedroom.",
        image: "https://i.postimg.cc/05F2v3t3/Screenshot-2026-02-16-121750.png",
        features: ["Bass Wood", "Faux Wood"]
    },
    {
        title: "INSULATED GLASS BLINDS (Sandwich Blinds)",
        description: "Insulated Glass Blinds are a path‑breaking sun protection and sound‑proofing solution with integrated blinds. These blinds are hygienically enclosed within glass so hands or paws can’t reach them.",
        image: "https://i.postimg.cc/6QtpSvHc/Screenshot-2026-02-16-121656.png",
        features: ["Venation Blind", "Aluminum Venation"]
    },
    {
        title: "SKYLIGHT BLINDS",
        description: "Skylight blinds give those hard‑to‑reach windows the benefits of light blockage and extra insulation. The insulating properties of skylight blinds make them extremely efficient at reducing considerable heat transfer.",
        image: "https://i.postimg.cc/jj07j2Z1/Screenshot-2026-02-16-121501.png",
        features: ["Blind Fabric", "Blackout"]
    },
    {
        title: "ROMAN BLINDS",
        description: "Roman blinds dress your windows with pleats. Whether you prefer traditional patterns for the kitchen or floral designs for the lounge, Roman blinds are easy to use—just pull the cord to adjust the blinds according to your requirement.",
        image: "https://i.postimg.cc/Hx14F3qR/Screenshot-2026-02-16-121318.png",
        features: ["Blind Fabric", "Blackout", "Sunscreen", "Translucent"]
    },
    {
        title: "MOTORIZED CURTAIN TRACKER",
        description: "Curtains can be sheer or blackout to control the privacy of your room. Now operate your curtains with a single touch to open or close them.",
        image: "https://i.postimg.cc/Qxm41L2N/Screenshot-2026-02-16-121113.png",
        features: ["Motor Operations", "Automation", "Remote", "Mobile App"]
    },
    {
        title: "LEATHERITE BLINDS",
        description: "A classically simple and timelessly elegant Wintree‑made leatherite venation blinds. Take control of onboard mood, lighting, atmosphere, and temperature.",
        image: "https://i.postimg.cc/90k3hryK/Screenshot-2026-02-16-124233.png",
        features: ["Blind Fabric", "Leatherite", "Remote", "Mobile App"]
    },
    {
        title: "PLEATED MOSQUITO MESH",
        description: "Pleated insect protection mesh is designed for doors and windows to provide protection from mosquitoes and insects. Pleated mesh allows natural air and light, providing proper ventilation and an outside view.",
        image: "https://i.postimg.cc/RVJytC7K/Screenshot-2026-02-16-124340.png",
        features: ["Mesh Fabric", "Screen", "Blackout"]
    },
];

const ProductPage = () => {
    const navigate = useNavigate();
      const [isDownloading, setIsDownloading] = useState(false);

     const handleImageDownload = async () => {
    try {
      setIsDownloading(true);
      const response = await fetch(STATIC_IMAGE_URL);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "brochure.jpg";
      link.click();

      window.URL.revokeObjectURL(url);
      toast.success("Download successful");
    } catch {
      toast.error("Download failed");
    } finally {
      setIsDownloading(false);
    }
  };

    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Optional: adds smooth scrolling
        });
    }, []);


    const handleCategoryClick = (shadeName) => {
        navigate(`/shop?shadeName=${encodeURIComponent(shadeName)}`);
    };

    return (
        <div className="min-h-screen bg-[#F3F8F2] font-sans text-gray-800">
            {/* Premium Header */}
            <div className="relative !pb-0">
                  <div className="flex items-center min-w-[50px] sm:min-w-[90px] md:min-w-[110px]  !ml-auto mr-7">
            <span
              onClick={handleImageDownload}
              title="Download Brochure"
              className={`inline-flex items-center !ml-auto mt-4 mr-7 gap-0 md:gap-1 text-[#661E33] font-semibold cursor-pointer hover:text-white hover:bg-[#661E33] transition-all duration-300 whitespace-nowrap text-sm sm:text-sm ${isDownloading ? 'opacity-50 pointer-events-none' : ''} border-2 border-[#D1BC9F] rounded-md !p-1 md:p-2 shadow-sm`}
            >
             
  <span className="hidden sm:inline">Download Brochure</span>
              <Download className={`text-sm h-4 w-4 sm:text-sm ${isDownloading ? 'animate-bounce' : ''}`} />
              <span className="hidden xs:inline">{isDownloading ? 'Downloading...' : 'Download'}</span>
              <span className="xs:hidden">{isDownloading ? '...' : ''}</span>
            </span>
          </div>

                {/* Header Content */}
                <div className="relative flex flex-col lg:flex-row items-start max-w-[87rem] mx-auto px-6 lg:px-10 pb-0 lg:pb-6 gap-3 lg:gap-0">                    
                    <div className="flex-1 mx-auto">
                    <div className="flex items-center justify-between mx-auto">
                    <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full shadow-sm mb-4 border border-[#588157]/20">
                        <span className="relative flex h-2 w-2">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#661E33] opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-2 w-2 bg-[#661E33]"></span>
                        </span>
                        <span className="text-xs font-semibold text-[#661E33] uppercase tracking-wider">
                            Premium Collection {new Date().getFullYear()}
                        </span>
                    </div>
                   
                    </div>

                    <Heading
                        text={"Transform Your Space With Elegance"}
                    />
                    <hr className="heading-seperator border-t-4 border-[#66944b] opacity-100 w-24 mt-1 mx-auto" />

                    {/* <p className="text-[] mt-4 max-w-2xl text-sm lg:text-base leading-relaxed">
                            Discover our exclusive range of premium blinds designed to bring sophistication,
                            functionality, and comfort to every room of your home or office.
                        </p> */}
                    {/* <p className="-mt-4  sm:mt-4 md:mt-5
text-xs sm:text-sm md:text-base lg:text-lg 
max-w-full sm:max-w-xl md:max-w-2xl 
leading-relaxed text-center md:text-left px-2 sm:px-0">
  Discover our exclusive range of premium blinds designed to bring sophistication,
  functionality, and comfort to every room of your home or office.
</p> */}
                    <p className="mt-1 sm:!my-3 md:!my-3
text-sm sm:text-sm md:text-base lg:text-lg
max-w-[320px] sm:max-w-xl md:max-w-2xl
leading-relaxed text-center md:text-left
mx-auto md:mx-0 text-balance">
                        Discover our exclusive range of premium blinds designed to bring sophistication,
                        functionality, and comfort to every room of your home or office.
                    </p>
                </div>

                    {/* Right Side - Logo Image Only */}
                    <div className="w-full lg:w-80 lg:mt-1 md:my-2 md:mb-2 !mb-5 lg:!mb-0 sm:my-2 lg:pt-12 pr-4 flex justify-center lg:justify-end">
                        {/* <img
                            src={logo}
                            alt="Umbrona Designs"
                            className="hidden lg:block h-14 sm:h-16 md:h-18 lg:h-20 w-auto object-contain"
                        /> */}

                           
                    </div>
                </div>
            </div>

            {/* Main Layout Grid */}
            <div className="flex flex-col lg:flex-row max-w-full mx-auto px-6 gap-3 lg:px-10 lg:py-3">
                {/* Left Content Area */}
                <div className="flex-1 !pb-0 lg:pb-10 ">
                    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-2">
                        {products.map((item, index) => (
                            <div key={index} className="group bg-white rounded-2xl shadow-md hover:shadow-2xl transition-all duration-500 overflow-hidden border border-[#D1BC9F]/30 hover:border-[#661E33]/40 transform hover:-translate-y-2 hover:bg-gradient-to-b hover:from-white hover:to-[#FAF7F3]" onClick={() => handleCategoryClick(item.title)}>
                                {/* Image Container */}
                                <div className="relative overflow-hidden h-44">
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                                        loading="lazy"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                                    {/* Quick View Button */}
                                    <div className="absolute bottom-3 left-3 right-3 opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-2 group-hover:translate-y-0">
                                        <button title="Quick View" className="w-full py-2 bg-white/95 backdrop-blur-sm text-[#3A5A40] text-xs font-semibold rounded-lg hover:bg-[#588157] hover:text-white transition-colors shadow-lg">
                                            Quick View
                                        </button>
                                    </div>
                                </div>

                                {/* Content Container */}
                                <div className="p-4">
                                    <h3 className="text-[#661E33] font-bold text-sm mb-1.5 line-clamp-1 group-hover:text-[#D1BC9F] transition-colors duration-300 cursor-pointer" onClick={() => handleCategoryClick(item.title)}>
                                        {item.title}
                                    </h3>

                                    <p className="text-[11px] text-gray-500 mb-3 line-clamp-2 leading-relaxed">
                                        {item.description}
                                    </p>

                                    <div className="mb-3">
                                        <p className="text-[9px] font-semibold text-gray-400 uppercase tracking-wider mb-1.5 flex items-center gap-1">
                                            <span className="w-1 h-1 bg-[#661E33] rounded-full group-hover:bg-[#D1BC9F] transition-colors"></span>
                                            Features
                                        </p>
                                        <div className="flex flex-wrap gap-1">
                                            {item.features?.map((f, i) => (
                                                <span
                                                    key={i}
                                                    className="text-[8px] bg-[#F8F5F0] px-2 py-1 rounded-full text-gray-700 font-medium border border-[#D1BC9F]/40 group-hover:border-[#661E33]/40 group-hover:bg-[#661E33] group-hover:text-white transition-all duration-300"
                                                >
                                                    {f}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Right Green Sidebar Section */}
                <div className='flex flex-col items-center justify-start !pt-0'>
                <div className="w-full lg:w-80 lg:ml-6 mb-0 lg:mb-0">
                    {/* Sticky Container */}
                    <div className="lg:sticky lg:top-24">
                        {/* CARD */}
                        <div className="relative flex flex-col bg-gradient-to-b lg:mr-2 from-[#588157] to-[#456b44] my-3 lg:!my-0 lg:!mb-3 text-white rounded-[2rem] sm:rounded-[.5rem] p-6 sm:p-8 shadow-[0_20px_60px_rgba(0,0,0,0.25)] overflow-hidden">
                            {/* Decorative blobs */}
                            <div className="absolute inset-0 opacity-5 overflow-hidden pointer-events-none">
                                <div className="absolute top-0 right-0 w-32 h-32 bg-white rounded-full -mr-16 -mt-16"></div>
                                <div className="absolute bottom-0 left-0 w-24 h-24 bg-white rounded-full -ml-12 -mb-12"></div>
                            </div>

                            {/* CONTENT WRAPPER */}
                            <div className="relative flex flex-col gap-6 sm:gap-8 h-full">
                                {/* BRAND */}
                                <div className="text-center">
                                    <div className="flex justify-center mb-2">
                                        <div className="bg-white" style={{ background: 'transparent' }}>
                                            <img
                                                src="https://i.postimg.cc/05BvGtbK/Screenshot-2026-02-17-105850.png"
                                                alt="umbrona designs"
                                                className="h-16 sm:h-20 md:h-24 w-auto object-contain"
                                            />
                                        </div>
                                    </div>
                                    <div className="w-14 h-[2px] bg-white/30 mx-auto mt-3"></div>
                                </div>

                                {/* IMAGE BLOCK */}
                                <div className="relative">
                                    <div className="overflow-hidden rounded-2xl sm:rounded-[2rem] border border-white/20 shadow-xl">
                                        <img
                                            src="https://images.unsplash.com/photo-1586023492125-27b2c045efd7?auto=format&fit=crop&q=80&w=500"
                                            alt="Interior"
                                            className="w-full h-48 sm:h-56 lg:h-48 object-cover"
                                        />
                                    </div>

                                    {/* Premium badge */}
                                    <div className="absolute -bottom-3 right-3 bg-white text-[#3A5A40] px-3.5 py-1 rounded-full shadow-lg">
                                        <span className="text-xs font-semibold">
                                            ✦ Premium
                                        </span>
                                    </div>
                                </div>

                                {/* DECORATIVE DIVIDER */}
                                <div className="relative pt-2">
                                    {/* Gold bar */}
                                    <div className="flex justify-center">
                                        <div className="w-24 h-[2px] bg-gradient-to-r from-transparent via-[#C8A87D] to-transparent"></div>
                                    </div>

                                    {/* Diamond separator */}
                                    <div className="flex justify-center gap-1 my-2">
                                        <span className="w-1.5 h-1.5 bg-[#C8A87D] rotate-45"></span>
                                        <span className="w-1.5 h-1.5 bg-white/30 rotate-45"></span>
                                        <span className="w-1.5 h-1.5 bg-[#C8A87D] rotate-45"></span>
                                    </div>

                                    {/* Decorative text line */}
                                    <p className="text-[11px] sm:text-[13px] tracking-[0.3em] sm:tracking-[0.4em] text-white/50 uppercase text-center font-medium">
                                        ✦ premium quality ✦
                                    </p>
                                </div>

                                {/* TRUST SECTION */}
                                <div className="text-center">
                                    <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-md px-4 py-2 rounded-full">
                                        <span className="w-2 h-2 bg-white rounded-full animate-pulse"></span>
                                        <span className="text-xs sm:text-sm tracking-widest font-medium">
                                            TRUSTED SINCE 2008
                                        </span>
                                    </div>

                                    <p className="mt-4 text-sm sm:text-base italic opacity-95 leading-relaxed">
                                        "India's one of the most selling & trusted brand"
                                    </p>

                                    <p className="mt-2 text-xs opacity-75">
                                        &
                                    </p>

                                    <p className="mt-2 text-sm sm:text-base italic opacity-95 leading-relaxed">
                                        "Crafting Luxury Window Solutions"
                                    </p>
                                </div>

                                {/* FOOTER BADGE */}
                                <div className="mt-auto text-center border-t border-white/20 pt-4">
                                    <p className="text-xs sm:text-sm font-semibold tracking-[0.15em] sm:tracking-[0.2em] flex items-center justify-center gap-2 sm:gap-3">
                                        <span className="w-1.5 h-1.5 bg-[#C8A87D] rounded-full animate-pulse"></span>
                                        NOW AVAILABLE IN YOUR CITY
                                        <span className="w-1.5 h-1.5 bg-[#C8A87D] rounded-full animate-pulse"></span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              

                  {/* Two Cards Section - Logo/Rooms and Address */}
            <div className="w-full mx-2">
                <div className="grid grid-cols-1 lg:w-80 lg:ml-6 gap-1 sm:gap-2 lg:gap-0 mb-3 lg:!mb-0">
                    {/* Left Card - Logo and Rooms - Very Compact */}
                    <div className="bg-gradient-to-br from-[#66944C] to-[#66944C] rounded-lg p-3 ml-2 text-white shadow-sm lg:!mb-0 mb-3">
                        {/* Logo */}
                        <div className="text-center mb-1">
                            {/* Logo Image */}
                            <div className="flex justify-center mt-2">
                                <img
                                    src="https://i.postimg.cc/7hnJ6JxF/Screenshot-2026-02-16-142857.png"
                                    alt="umbrona designs"
                                    className="h-14 w-auto object-contain"
                                />
                            </div>

                            {/* Icons Grid - Living room, Bedroom, etc. */}
                            <div className="grid grid-cols-2 lg:grid-cols-1 gap-3 mt-1">  <div className="flex items-center gap-2 px-3 py-2 rounded-full shadow-lg transition-all duration-300 group">
                                <House className="w-4 h-4 text-white" strokeWidth={1.8} />
                                <span className="text-xs font-medium text-white/80 group-hover:text-white">
                                    Living room
                                </span>
                            </div>

                                {/* Bedroom */}
                                <div className="flex items-center gap-2 px-3 py-2 rounded-full shadow-lg transition-all duration-300 group">
                                    <BedSingle className="w-4 h-4 text-white" strokeWidth={1.8} />
                                    <span className="text-xs font-medium text-white/80">Bedroom</span>
                                </div>

                                {/* Kids room */}
                                <div className="flex items-center gap-2 px-3 py-2 rounded-full shadow-lg transition-all duration-300 group">
                                    <Baby className="w-4 h-4 text-white" strokeWidth={1.8} />
                                    <span className="text-xs font-medium text-white/80">Kids room</span>
                                </div>

                                {/* Operation */}
                                <div className="flex items-center gap-2 px-3 py-2 rounded-full shadow-lg transition-all duration-300 group">
                                    <Bolt className="w-4 h-4 text-white" strokeWidth={1.8} />
                                    <span className="text-xs font-medium text-white/80">Operation</span>
                                </div>

                                {/* Home Office */}
                                <div className="flex items-center gap-2 px-3 py-2 rounded-full shadow-lg transition-all duration-300 group">
                                    <Building2 className="w-4 h-4 text-white" strokeWidth={1.8} />
                                    <span className="text-xs font-medium text-white/80">Home Office</span>
                                </div>

                                {/* Bathroom */}
                                <div className="flex items-center gap-2 px-3 py-2 rounded-full shadow-lg transition-all duration-300 group">
                                    <Bath className="w-4 h-4 text-white" strokeWidth={1.8} />
                                    <span className="text-xs font-medium text-white/80">Bathroom</span>
                                </div>

                                {/* Kitchen */}
                                <div className="flex items-center gap-2 px-3 py-2 rounded-full shadow-lg transition-all duration-300 group">
                                    <CookingPot className="w-4 h-4 text-white" strokeWidth={1.8} />
                                    <span className="text-xs font-medium text-white/80">Kitchen</span>
                                </div>

                                {/* Manual */}
                                <div className="flex items-center gap-2 px-3 py-2 rounded-full shadow-lg transition-all duration-300 group">
                                    <Settings2 className="w-4 h-4 text-white" strokeWidth={1.8} />
                                    <span className="text-xs font-medium text-white/80">Manual</span>
                                </div>

                                {/* Motorized */}
                                <div className="flex items-center gap-2 px-3 py-2 rounded-full shadow-lg transition-all duration-300 group">
                                    <MonitorCog className="w-4 h-4 text-white" strokeWidth={1.8} />
                                    <span className="text-xs font-medium text-white/80">
                                        Motorized Wireless
                                    </span>
                                </div>

                            </div>


                        </div>
                    </div>

                    {/* Right Card - Address and Contact - Very Compact */}
                    <div className="bg-white rounded-lg p-3 shadow-sm border border-gray-100 mb-3 ml-1 lg:!mb-0">
                        {/* A Venture of - Image Only */}
                        <div className="flex justify-center mb-2 mt-4">
                            <img
                                src={logo}


                                alt="Umbrona Designs"
                                className="h-14 w-auto object-contain"
                            />
                        </div>

                        {/* Company Name - Now below image */}
                        <p className="text-center text-[9px] font-semibold text-[#3A5A40] mb-0">
                            UMBRONA DESIGNS
                        </p>

                        {/* Company Details */}
                        <div className="space-y-0.5 mt-1">
                            <p className="text-[12px] text-gray-600 leading-tight text-center">
                               4, Bhagwanpur Ind. Park, Derabassi, Punjab 140507
                            </p>
                            <div className="flex items-center justify-center gap-2 text-[12px] text-gray-600">
                                <span> Mob: 📞 81466 16627</span>
                                <span>🌐 umbrona.com</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
              </div>
            </div>

          
        </div>
    );
};

export default ProductPage;